import axios from 'axios'
import { SAVINGS_PLAN_STATUS } from 'src/features/savings_plan/constants'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'cfgCommon/endpoints'

export async function createSavingsPlanSubscription({
    savingsPlanId,
    savingsPlan,
    subscriptionStateChange,
    idAsesor,
    businessAdvisor,
    branchOffice,
    subscriptionInfo,
    leadId,
    clientId,
    quotes,
    form
}) {
    const {
        datamaster_id,
        car_lot_id,
        pea,
        pea_instalment,
        suggested_factory_price,
        financing_percentage,
        valid_to,
        instalment_quantity,
        year,
        product_description,
        plan_description,
        extraordinary_percentage,
        extraordinary_instalment_amount,
        aditional_percentage = null,
        aditional_instalment_amount,
        published,
        is_first_instalment_in_subscription,
        benefits,
        SavingsPlansInstalmentsRanges,
        bonification = {}
    } = savingsPlan
    const {
        subscription_number,
        subscription_number_version,
        subscription_state,
        id: subscription_id
    } = subscriptionInfo
    try {
        const parseAditionalPercentage = !aditional_percentage || typeof aditional_percentage === 'number' ? aditional_percentage : aditional_percentage.replace(',','.')
        const savingsPlansSubscription = {
            SavingsPlansSubscription: {
                id: subscription_id,
                datamaster_id,
                car_lot_id,
                pea,
                pea_instalment,
                suggested_factory_price,
                financing_percentage,
                valid_to,
                instalment_quantity,
                subscription_instalment_amount: form.subscriptionInstallment,
                year,
                product_description,
                plan_description,
                extraordinary_percentage,
                extraordinary_instalment_amount,
                aditional_percentage: parseAditionalPercentage,
                aditional_instalment_amount,
                published,
                is_first_instalment_in_subscription,
                benefits,
                instalment_ranges: SavingsPlansInstalmentsRanges,
                total_discount: bonification.total_discount,
                subscription_quote_discount: bonification.subscription_quote_discount,
                additional_benefits: form.aditionalBenefits,
                branch_office_id: branchOffice,
                business_advisor_id: idAsesor,
                businessAdvisor,
                savings_plans_id: savingsPlanId,
                comment: form.comment,
                subscription_state: subscriptionStateChange,
                lead_id: leadId,
                client_id: clientId,
                subscription_number,
                subscription_number_version,
                quotes,
                added_discount: form.added_discount,
                canceled_reservation: subscription_state === SAVINGS_PLAN_STATUS.RESERVADO,
                payment_method: form.payment_method
            }
        }

        const { data } = await axios.post(
            `${SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT}`,
            savingsPlansSubscription
        )

        return data
    } catch (error) {
        if (error?.response?.data?.message)
            error.message = error.response.data.message

        throw error
    }
}
